import { render, staticRenderFns } from "./proIndex.vue?vue&type=template&id=1888ce6a&scoped=true"
import script from "./proIndex.vue?vue&type=script&lang=js"
export * from "./proIndex.vue?vue&type=script&lang=js"
import style0 from "./proIndex.vue?vue&type=style&index=0&id=1888ce6a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1888ce6a",
  null
  
)

export default component.exports